import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OnlineRegFamilies } from '../../household-data.model';
import { TylerMatTableDataSource } from '../../../../shared-components/angular-material/extended.class';
import { StudentService } from '../../../../shared-components/student/student.service';
import { ErrorList } from '../../../../shared-components/controls/error-prompt/error-list.model';
import { OnlineRegistrationService } from '../../online-registration.service';
import { YearService } from '../../../../shared-components/year/year.service';

@Component({
  selector: 'app-multiple-families',
  templateUrl: './multiple-families.component.html',
  styleUrls: ['./multiple-families.component.css']
})
export class MultipleFamiliesComponent implements OnInit {
  errors: ErrorList[] = [];
  isUHD: boolean;
  families: OnlineRegFamilies[] = [];
  tableData = new TylerMatTableDataSource();
  selectedFamilyId: number;
  gradeLevelMessage: string;
  gradeLevelData: string;
  note: string;
  columnsToDisplay = ['Select', 'Role', 'Students'];
  constructor(
    private studentService: StudentService,
    private yearService: YearService,
    private onlineRegistrationService: OnlineRegistrationService,
    private dialog: MatDialogRef<MultipleFamiliesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.isUHD = this.data.isUHD;
    if (!this.isUHD) {
      this.columnsToDisplay.push('Status');
    }
    this.onlineRegistrationService.getORYearGradeLevels(-1).subscribe(data => {
      if (data && data.indexOf('to') > 0) {
        this.gradeLevelMessage = 'Online Registration is currently open for grades ';
        this.gradeLevelData = data + '.';
        if (!this.isUHD) {
          this.note = 'You are associated with students in those grades in multiple families. For which family do you wish to access Online registration:';
        }

      } else if (data && data.length > 0) {
        this.gradeLevelMessage = 'Online Registration is currently open for grade ';
        this.gradeLevelData = data + '.';
        if (!this.isUHD) {
          this.note = 'You are associated with students in that grade in multiple families. For which family do you wish to access Online registration:';
        }
      }
      else {
        this.gradeLevelMessage = 'Online Registration is currently open for all grades.';
        if (!this.isUHD) {
          this.note = 'You are associated with students in multiple families. For which family do you wish to access Online registration:';
        }
      }

      if (this.isUHD) {
        this.note = 'You are associated with students in multiple families. For which family do you wish to access Update Household Data forms:';
      }

    });
    this.families = this.data.families;
    this.families.forEach(element => {
      element.Students = [];
      let studentIds: string[] = [];
      studentIds = element.StudentIds.split(',');
      studentIds.forEach(std => {
        const student = this.studentService.students.find(x => x.Id == parseInt(std, 10));
        if (student) {
          element.Students.push(student);
        }
      });
    });
    if (this.families && this.families.length > 0) {
      this.tableData.data = this.families;
    }
  }
  cancelClick() {
    this.dialog.close();
  }
  okClick() {
    if (this.selectedFamilyId > 0) {
      this.onlineRegistrationService.familyId = this.selectedFamilyId;
      const selectedFamily = this.families.find(x => x.FamilyId == this.selectedFamilyId);
      if (selectedFamily) {
        this.onlineRegistrationService.parentType = selectedFamily.ParentType;
      }
      this.dialog.close(this.selectedFamilyId);
    } else {
      const err: ErrorList = new ErrorList();
      err.errorMsg = 'Please select your role';
      err.fieldName = 'Role';
      err.fieldRef = undefined;
      this.errors.push(err);
    }
  }

  radioChange(ctrl) {
    if (ctrl && ctrl.value) {
      this.selectedFamilyId = ctrl.value;
      this.onlineRegistrationService.familyId = this.selectedFamilyId;
    }
  }
}
